<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout wrap>
      <v-flex
        xs12
      >
        <material-card
          color="green"
          :title="$t('Reports.tableHeading')"
          :text="$t('Reports.tableDescription')"
        >
          <div
            v-for="item in reports"
            :key="item.title"
            class="mt-5"
          >
            <v-list-item @click="$router.push({ path: item.path })">
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                <v-list-item-subtitle>{{ item.subTitle }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      reports: [{
        path: '/reports/progress',
        subTitle: 'View the progress of assessments',
        title: 'Progress Report',
      },
      {
        path: '/reports/standardsMeasure',
        subTitle: 'View the overall SAMM Progress',
        title: 'SAMM Model Report',
      }],
    };
  },
};
</script>

<style lang="scss" scoped>

</style>
